module.exports = __webpack_public_path__ + "static/4th-293b2de5d94529cda64234f146e8258d.png";